<template>
  <div style="background: #fff; padding: 10px">
    <el-row>
      <el-col :span="4" style="float: left; overflow: hidden" class="fix-width">
        <el-tree
          v-if="!nobuild"
          style="display: inline-block; width: 75%"
          :data="data"
          node-key="id"
          :default-expanded-keys="defexpand"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :highlight-current="true"
          ref="tree"
        ></el-tree>
        <p
          v-if="nobuild"
          style="
            margin-left: 50px;
            width: 20px;
            margin-top: 30px;
            display: inline-block;
          "
        >
          暂无数据
        </p>
        <div
          style="
            float: right;
            margin-right: 20px;
            display: inline-block;
            width: 1px;
            background: #8c939d;
            height: 800px;
          "
        />
      </el-col>
      <el-col :span="20">
        <!-- 左侧的显示楼栋列表 -->
        <div v-if="!showRightView">
          <div style="height: 40px">
            <el-button type="warning" plain class="el-icon-plus" @click="addBed"
              >添加</el-button
            >
          </div>
          <el-row :gutter="20">
            <el-col
              class="big_col"
              v-for="item in bedListData"
              :key="item.roomId"
            >
              <el-card shadow="always" class="card">
                <div class="card_top">
                  <i class="el-icon-edit top_icon" @click="infoEdit(item)"></i>
                  <i
                    class="el-icon-delete top_icon"
                    @click="infoDelete(item)"
                  ></i>
                  <i
                    class="el-icon-setting top_icon"
                    @click="roomSetting(item)"
                  ></i>
                  <i
                    class="el-icon-message-solid top_icon"
                    @click="closeWarning(item)"
                  ></i>
                </div>
                <div class="card_text">
                  房间编号: <span>{{ item.roomNo }}</span>
                </div>
                <div class="card_text">
                  房间别名: <span>{{ item.roomAlias }}</span>
                </div>
                <div class="card_text">
                  床位数量: <span>{{ item.bedNum }}</span>
                </div>
                <div class="card_text">
                  房间类型: <span>{{ bedNumToType(item.bedNum) }}</span>
                </div>
                <div class="card_text">
                  护理类型: <span>{{ item.levelCareName }}</span>
                </div>
                <div class="card_text">
                  是否有厕所:
                  <span>{{ item.hasToilet == 0 ? "否" : "是" }}</span>
                </div>
                <div class="card_text">
                  入住人数: <span>{{ item.checkInNum }}</span>
                </div>
                <div class="card_text">
                  房间朝向: <span>{{ directToStr(item.roomDirection) }}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 添加弹窗 -->
    <el-dialog
      title="添加房间"
      :visible.sync="addRoomVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        :model="addRoomForm"
        label-width="120px"
        :rules="addRoomRules"
        ref="addRoomForm"
      >
        <el-form-item label="房间编号" prop="roomNo">
          <el-input
            v-model.trim="addRoomForm.roomNo"
            :maxlength="12 - addRoomLeft.length"
            auto-complete="off"
            style="width: 374px"
          >
            <template slot="prepend">{{ addRoomLeft }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="房间别名" prop="roomAlias">
          <el-input
            v-model.trim="addRoomForm.roomAlias"
            :maxlength="10"
            auto-complete="off"
            style="width: 374px"
          ></el-input>
        </el-form-item>

        <el-form-item label="楼层号" prop="floorNo">
          <el-select
            v-model="addRoomForm.floorNo"
            placeholder="请选择"
            style="width: 374px"
            @change="addFloorChange"
          >
            <el-option
              v-for="item in nowfloorList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="床位数量" prop="bedNum">
          <el-input
            v-model="addRoomForm.bedNum"
            @keyup.native="numberChange"
            @change="numberChange"
            :maxlength="2"
            type="number"
            auto-complete="off"
            style="width: 374px"
          ></el-input>
        </el-form-item>

        <el-form-item label="房间类型" prop="bedDirection">
          <el-select
            v-model="addRoomForm.roomType"
            placeholder="请选择"
            style="width: 374px"
            disabled
          >
            <el-option
              v-for="item in roomTypeList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="护理类型" prop="bedType">
          <el-select
            v-model="addRoomForm.bedType"
            placeholder="请选择"
            style="width: 374px"
          >
            <el-option
              v-for="item in bedTypeList"
              :key="item.id"
              :label="item.nursingCare"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="房间朝向" prop="roomDirection">
          <el-select
            v-model="addRoomForm.roomDirection"
            placeholder="请选择"
            style="width: 374px"
          >
            <el-option
              v-for="item in roomDirectionList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有厕所" prop="hasToilet">
          <el-select
            v-model="addRoomForm.hasToilet"
            placeholder="请选择"
            style="width: 374px"
          >
            <el-option
              v-for="item in hasToiletList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="btnLoading"
          plain
          @click="addRoomSubmit('addRoomForm')"
          >确定</el-button
        >
        <el-button plain @click.native="addRoomVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改床位 -->
    <el-dialog
      title="修改房间"
      :visible.sync="editRoomDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        :model="editRoomForm"
        label-width="120px"
        :rules="editRoomRule"
        ref="editRoomForm"
      >
        <el-form-item label="房间编号" prop="newroomNo">
          <el-input
            v-model.trim="editRoomForm.newroomNo"
            :maxlength="12 - addRoomLeft.length"
            auto-complete="off"
            style="width: 374px"
          >
            <template slot="prepend">{{ editRoomLeft }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="房间别名" prop="roomAlias">
          <el-input
            v-model.trim="editRoomForm.roomAlias"
            :maxlength="10"
            auto-complete="off"
            style="width: 374px"
          ></el-input>
        </el-form-item>

        <el-form-item label="楼层号" prop="floorNo">
          <el-input
            v-model="editRoomForm.floorNo"
            auto-complete="off"
            style="width: 374px"
            readonly
          ></el-input>
        </el-form-item>

        <el-form-item label="床位数量" prop="bedNum">
          <el-input
            v-model="editRoomForm.bedNum"
            auto-complete="off"
            style="width: 374px"
            readonly
          ></el-input>
        </el-form-item>

        <el-form-item label="房间类型" prop="roomType">
          <el-input
            v-model="editRoomForm.roomType"
            auto-complete="off"
            style="width: 374px"
            readonly
          ></el-input>
        </el-form-item>

        <el-form-item label="护理类型" prop="levelCareId">
          <el-select
            v-model="editRoomForm.levelCareId"
            placeholder="请选择"
            style="width: 374px"
            disabled
          >
            <el-option
              v-for="item in bedTypeList"
              :key="item.id"
              :label="item.nursingCare"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="房间朝向" prop="roomDirection">
          <el-select
            v-model="editRoomForm.roomDirection"
            placeholder="请选择"
            style="width: 374px"
          >
            <el-option
              v-for="item in roomDirectionList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有厕所" prop="hasToilet">
          <el-select
            v-model="editRoomForm.hasToilet"
            placeholder="请选择"
            style="width: 374px"
          >
            <el-option
              v-for="item in hasToiletList"
              :keys="item.value"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="btnLoading"
          plain
          @click="editRoomSubmit('editRoomForm')"
          >确定</el-button
        >
        <el-button plain @click.native="editRoomDialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <!-- 屏蔽报警 -->
    <el-dialog
      title="报警屏蔽"
      :visible.sync="warningDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <el-form :model="warningForm" label-width="120px">
        <el-form-item label="启动报警时长" prop="silentTime">
          <el-input v-model.trim="warningForm.silentTime" style="width: 130px">
            <template slot="append">分</template>
          </el-input>
          <el-button
            style="display: inline; margin-left: 6px"
            @click="settingTime"
            >确认</el-button
          >
        </el-form-item>
        <el-form-item label="屏蔽报警开关" prop="onOff">
          <el-switch
            v-model="warningForm.onOff"
            active-color="#13ce66"
            @change="changeStatus"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="warningDialogVisible = false" type="primary"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
// 查询机构内的房间,根据楼栋楼层来筛选
export default {
  name: "RoomView",
  components: {
  },
  data() {
    return {
      layout: JSON.parse(JSON.stringify([])),
      draggable: false,
      resizable: false,
      mirrored: false,
      addBuildLoading: false,
      responsive: false,
      rowHeight: 36,
      colNum: 36,
      showEditView: false,
      saveText: "编辑", //
      nobuild: false,
      data: [],
      defexpand: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      currentBuildInfo: {},
      currentRoomId: "",
      currentBuildId: "",
      currentfloorNo: "",
      getRoomJson: "",
      addRoomLeft: "",
      editRoomLeft: "",
      showSaveBtn: true,
      showRightView: false, //显示楼栋视图操作
      bedListData: [
        {
          bedNum: 0,
          checkInNum: 0,
          floorNo: 0,
          hasToilet: 0,
          levelCareId: "",
          levelCareName: "",
          roomAlias: "",
          roomDirection: 0,
          roomId: 0,
          roomNo: "",
          roomType: 0,
        },
      ],
      btnLoading: false,
      addRoomVisible: false,
      nowfloorList: [], //当前楼层的下拉选框
      addRoomForm: {},
      bedTypeList: [
        {
          id: "",
          nursingCare: "",
          nursingProject: "",
          remark: "",
        },
      ],
      roomTypeList: [
        {
          value: 1,
          label: "单人间",
        },
        {
          value: 2,
          label: "双人间",
        },
        {
          value: 3,
          label: "三人间",
        },
        {
          value: 4,
          label: "四人及四人以上房间",
        },
      ],
      hasToiletList: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      roomDirectionList: [
        {
          value: 1,
          label: "东",
        },
        {
          value: 2,
          label: "西",
        },
        {
          value: 3,
          label: "南",
        },
        {
          value: 4,
          label: "北",
        },
      ],
      addRoomRules: {
        roomNo: [
          { required: true, message: "请输入房间编号" },
          { min: 1, message: "房间编号不能为空" },
        ],
        floorNo: [{ required: true, message: "请选择楼层数" }],
        bedNum: [{ required: true, message: "请输入床位数量" }],
        hasToilet: [{ required: true, message: "请选择是否带厕所" }],
        roomDirection: [{ required: true, message: "请选择房间朝向" }],
        bedType: [{ required: true, message: "请选择房间护理类型" }],
      },
      editRoomRule: {
        newroomNo: [
          { required: true, message: "请输入房间编号" },
          { min: 1, message: "房间编号不能为空" },
        ],
        hasToilet: [{ required: true, message: "请选择是否带厕所" }],
        roomDirection: [{ required: true, message: "请选择房间朝向" }],
      },
      editRoomDialogVisible: false,
      editRoomForm: {
        levelCareId: "",
      },
      warningDialogVisible: false, //报警弹窗
      warningForm: {
        silentTime: "",
        onOff: false,
      },
      settingRoomId: "",
    };
  },
  methods: {
    //   获取护理等级列表
    getSelfcareStatusList() {
      let params = {
        pageNum: 1,
        pageSize: 999,
        groupId: Number(sessionStorage.getItem("groupId")),
      };
      this.$postJson("omc/levelCare/select", params).then((res) => {
        if (res.code == 200) {
          this.bedTypeList = res.result.list;
        } else {
          this.bedTypeList = [];
        }
      });
    },
    //获取楼栋列表
    getBuildList() {
      this.$postJson("omc/Building/showAlls").then((res) => {
        var treeData = [];
        res = res.result;
        for (var i = 0; i < res.length; i++) {
          var floorNum = res[i].floorNum; //楼层数
          var item = {
            label: res[i].buildingName,
            id: res[i].buildingId,
            buildInfo: res[i],
            level: 0,
          };
          // 自己显示第一个楼栋的全部床位,展开第一个楼栋
          if (i == 0) {
            this.defexpand.push(res[i].buildingId);
            this.currentBuildId = res[i].buildingId;
            this.currentBuildInfo = res[i];
            this.currentfloorNo = "";
            this.getBedData({
              buildingId: res[i].buildingId,
            });
          }

          var children = [];
          //有房间的楼层列表
          for (var j = 1; j <= floorNum; j++) {
            //有床位的房间列表
            children.push({
              buildId: res[i].buildingId,
              id: res[i].buildingId + "" + j,
              floorNo: j,
              label: j + "层",
              buildInfo: res[i],
              level: 1,
            });
          }
          children.reverse();
          item.children = children;
          treeData.push(item);
        }
        this.data = treeData;
      });
    },
    directToStr(number) {
      if (number == 1) {
        return "东";
      } else if (number == 2) {
        return "西";
      } else if (number == 3) {
        return "南";
      } else if (number > 3) {
        return "北";
      }
    },
    numToType(number) {
      for (var i = 0; i < this.bedTypeList.length; i++) {
        if (this.bedTypeList[i].id * 1.0 == number * 1.0) {
          if (this.bedTypeList[i].nursingCare.length > 8) {
            return this.bedTypeList[i].nursingCare.substring(0, 8);
          } else {
            return this.bedTypeList[i].nursingCare;
          }
        }
      }
      return "";
    },
    correctCareLevelId(number) {
      for (var i = 0; i < this.bedTypeList.length; i++) {
        if (this.bedTypeList[i].id * 1.0 == number * 1.0) {
          return this.bedTypeList[i].id;
        }
      }
      return "";
    },
    bedNumToType(number) {
      if (number == 0) {
        return "无";
      } else if (number == 1) {
        return "单人间";
      } else if (number == 2) {
        return "双人间";
      } else if (number == 3) {
        return "三人间";
      } else if (number > 3) {
        return "四人及四人以上房间";
      }
    },
    numberChange() {
      this.addRoomForm.bedNum = this.addRoomForm.bedNum
        .replace(/[^\.\d]/g, "")
        .replace(".", "");
      if (this.addRoomForm.bedNum.length > 2) {
        this.addRoomForm.bedNum = this.addRoomForm.bedNum.substring(0, 2);
      }
      if (this.addRoomForm.bedNum == "1") {
        this.addRoomForm.roomType = 1;
      } else if (this.addRoomForm.bedNum == "2") {
        this.addRoomForm.roomType = 2;
      } else if (this.addRoomForm.bedNum == "3") {
        this.addRoomForm.roomType = 3;
      } else if (this.addRoomForm.bedNum > 3) {
        this.addRoomForm.roomType = 4;
      } else {
        this.addRoomForm.roomType = "";
      }
    },
    //获取房间列表
    getBedData(json) {
      this.getRoomJson = json;
      this.$postJson("omc/Room/queryRoomInfo", json).then(
        (res) => {
          this.bedListData = res.result;
        },
        (err) => {
          this.$message.error(err.message);
        }
      );
    },
    //点击获取数据
    handleNodeClick(data) {
      console.log(data);
      this.currentBuildInfo = data.buildInfo;
      var json = "";
      if (data.level == 0) {
        //点击楼栋
        this.showEditView = false;
        json = {
          buildingId: data.id,
        };
        this.currentBuildId = data.id;
        this.currentfloorNo = "";
        this.showSaveBtn = false;
      } else if (data.level == 1) {
        this.showEditView = true;
        json = {
          buildingId: data.buildId,
          floorNo: data.floorNo,
        };
        this.currentBuildId = data.buildId;
        this.currentfloorNo = data.floorNo;
        this.showSaveBtn = true;
        if (this.showRightView) {
          this.editView();
        }
      }

      this.getBedData(json);
    },
    backList() {
      this.showRightView = false;
    },
    //保存视图
    saveView() {
      if (this.saveText == "编辑") {
        this.saveText = "保存";
        this.draggable = true;
        this.resizable = true;
        this.isShowEdit = true;
      } else {
        this.saveText = "编辑";
        this.draggable = false;
        this.resizable = false;
        this.isShowEdit = false;
        var info = {
          buildingId: this.currentBuildId,
          floorNo: this.currentfloorNo,
          roomSort: JSON.stringify(this.layout),
        };
        this.$postJson("omc/room/saveRoomSort", info).then((res) => {
          this.$message.success("保存成功");
        });
      }
    },
    addFloorChange() {
      var isBuildNo = this.currentBuildInfo.isBuildNo; //是否带楼栋编号
      var isFloorNo = this.currentBuildInfo.isFloorNo; //是否带楼层编号

      if (this.addRoomForm.floorNo == "") {
        if (isBuildNo == 1) {
          this.addRoomLeft =
            this.currentBuildInfo.buildingNo + this.currentBuildInfo.buildLink;
        } else {
          this.addRoomLeft = "";
        }
      } else {
        if (isBuildNo == 1) {
          if (isFloorNo == 1) {
            this.addRoomLeft =
              this.currentBuildInfo.buildingNo +
              this.currentBuildInfo.buildLink +
              this.addRoomForm.floorNo +
              this.currentBuildInfo.floorLink;
          } else {
            this.addRoomLeft =
              this.currentBuildInfo.buildingNo +
              this.currentBuildInfo.buildLink;
          }
        } else {
          if (isFloorNo == 1) {
            this.addRoomLeft =
              this.addRoomForm.floorNo + this.currentBuildInfo.floorLink;
          } else {
            this.addRoomLeft = "";
          }
        }
      }
    },
    addBed() {
      console.log(this.currentBuildInfo);

      var isBuildNo = this.currentBuildInfo.isBuildNo; //是否带楼栋编号
      var isFloorNo = this.currentBuildInfo.isFloorNo; //是否带楼层编号
      if (this.currentfloorNo == "") {
        if (isBuildNo == 1) {
          this.addRoomLeft =
            this.currentBuildInfo.buildingNo + this.currentBuildInfo.buildLink;
        } else {
          this.addRoomLeft = "";
        }
      } else {
        if (isBuildNo == 1) {
          if (isFloorNo == 1) {
            this.addRoomLeft =
              this.currentBuildInfo.buildingNo +
              this.currentBuildInfo.buildLink +
              this.currentfloorNo +
              this.currentBuildInfo.floorLink;
          } else {
            this.addRoomLeft =
              this.currentBuildInfo.buildingNo +
              this.currentBuildInfo.buildLink;
          }
        } else {
          if (isFloorNo == 1) {
            this.addRoomLeft =
              this.currentfloorNo + this.currentBuildInfo.floorLink;
          } else {
            this.addRoomLeft = "";
          }
        }
      }

      // if(this.currentfloorNo == ""){
      //     this.addRoomLeft = this.currentBuildInfo.buildingNo+this.currentBuildInfo.buildLink;
      // }else{
      //   this.addRoomLeft =         this.currentBuildInfo.buildingNo+this.currentBuildInfo.buildLink+this.currentfloorNo+this.currentBuildInfo.floorLink;
      // }

      this.nowfloorList = [];
      for (let i = 1; i <= this.currentBuildInfo.floorNum; i++) {
        this.nowfloorList.push({
          label: i + "层",
          value: i,
        });
      }

      this.addRoomVisible = true;
      this.addRoomForm = {
        buildingId: this.currentBuildId,
        floorNo: this.currentfloorNo,
        roomNo: "",
        bedNum: "",
        hasToilet: "",
        roomType: "",
        roomDirection: "",
        roomAlias: "",
        bedType: "",
      };
      console.log(this.addRoomForm);
      this.$nextTick(() => {
        this.$refs["addRoomForm"].resetFields();

        console.log(this.currentfloorNo);
        console.log(this.currentBuildId);
        console.log(this.nowfloorList);
        this.addRoomForm.floorNo = this.currentfloorNo;
        this.addRoomForm.buildingId = this.currentBuildId;
        console.log(this.addRoomForm);
      });
    },

    addRoomSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addRoomForm);
          var info = {
            roomNo: this.addRoomLeft + this.addRoomForm.roomNo,
            buildingId: this.addRoomForm.buildingId,
            bedNum: this.addRoomForm.bedNum,
            hasToilet: this.addRoomForm.hasToilet,
            floorNo: this.addRoomForm.floorNo,
            roomType: this.addRoomForm.roomType,
            roomDirection: this.addRoomForm.roomDirection,
            roomAlias: this.addRoomForm.roomAlias,
            levelCareId: this.addRoomForm.bedType,
          };
          console.log(info);
          this.btnLoading = true;
          this.$postForm("omc/Room/addRoom", info).then(
            (res) => {
              this.btnLoading = false;
              this.getBedData(this.getRoomJson);
              this.addRoomVisible = false;
              this.$message.success("添加房间成功");
            },
            (err) => {
              this.btnLoading = false;
              this.$message.error(err.message);
            }
          );
        }
      });
    },
    infoEdit(item) {
      item.newroomNo = "";
      item.buildingId = this.currentBuildInfo.buildingId;

      var isBuildNo = this.currentBuildInfo.isBuildNo; //是否带楼栋编号
      var isFloorNo = this.currentBuildInfo.isFloorNo; //是否带楼层编号
      this.editRoomLeft = "";
      //2 1
      if (isBuildNo == 1) {
        if (isFloorNo == 1) {
          this.editRoomLeft =
            this.currentBuildInfo.buildingNo +
            this.currentBuildInfo.buildLink +
            item.floorNo +
            this.currentBuildInfo.floorLink;
        } else {
          this.editRoomLeft =
            this.currentBuildInfo.buildingNo + this.currentBuildInfo.buildLink;
        }
      } else {
        if (isFloorNo == 1) {
          this.editRoomLeft = item.floorNo + this.currentBuildInfo.floorLink;
        } else {
          this.editRoomLeft = "";
        }
      }

      if (this.editRoomLeft == null || this.editRoomLeft == undefined) {
        this.editRoomLeft = "";
      }

      // this.editRoomLeft = this.currentBuildInfo.buildingNo+this.currentBuildInfo.buildLink+item.floorNo+this.currentBuildInfo.floorLink;
      this.editRoomDialogVisible = true;
      this.editRoomForm = Object.assign({}, item);
      this.editRoomForm.levelCareId = this.correctCareLevelId(
        this.editRoomForm.levelCareId
      );
      //editRoomLeft

      this.$nextTick(() => {
        this.$refs["editRoomForm"].resetFields();
        this.editRoomForm = Object.assign({}, item);
        this.editRoomForm.newroomNo = item.roomNo.substring(
          this.editRoomLeft.length,
          item.roomNo.length
        );
        this.editRoomForm.roomType = this.bedNumToType(
          this.editRoomForm.bedNum
        );
        this.editRoomForm.levelCareId = this.correctCareLevelId(
          this.editRoomForm.levelCareId
        );
      });
    },
    editRoomSubmit(formName) {
      this.$refs["editRoomForm"].validate((valid) => {
        if (this.editRoomForm.newroomNo == "") {
          this.$message.error("请输入房间编号");
          return;
        }
        var info = {
          roomId: this.editRoomForm.roomId,
          roomNo: this.editRoomLeft + this.editRoomForm.newroomNo,
          hasToilet: this.editRoomForm.hasToilet,
          roomDirection: this.editRoomForm.roomDirection,
          roomAlias: this.editRoomForm.roomAlias,
          buildingId: this.editRoomForm.buildingId,
          floorNo: this.editRoomForm.floorNo,
          levelCareId: this.editRoomForm.levelCareId,
        };
        this.btnLoading = true;
        this.$postForm("omc/Room/updateRoom", info).then(
          (res) => {
            this.getBedData(this.getRoomJson);
            this.editRoomDialogVisible = false;
            this.$message.success("修改成功");
            this.btnLoading = false;
          },
          (err) => {
            this.btnLoading = false;
            this.$message.error(err.message);
          }
        );
      });
    },
    infoDelete(item) {
      this.$confirm("确认删除该房间吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
        center : true
      })
        .then(() => {
          var info = {
            roomId: item.roomId,
          };
          this.$postForm("omc/Room/delRoomById", info).then(
            (res) => {
              this.getBedData(this.getRoomJson);
              this.$message.success("删除成功");
            },
            (err) => {
              this.$message.error(err.message);
            }
          );
        })
        .catch(() => {});
    },
    editView() {
      this.showRightView = true;
      var info = {
        buildingId: this.currentBuildId,
        floorNo: this.currentfloorNo,
      };
      // 获取楼栋视图
      this.$postJson("omc/room/queryRoomSort", info).then((res) => {
        var layoutList = [];
        if (res != null) {
          layoutList = JSON.parse(res.roomSort);
        }
        var layoutData = [];
        for (var i = 0; i < this.bedListData.length; i++) {
          var item = {
            x: 0,
            y: 0,
            w: 3,
            h: 2,
            i: this.bedListData[i].roomId,
            text: "" + this.bedListData[i].roomNo,
          };
          for (var j = 0; j < layoutList.length; j++) {
            if (layoutList[j].i == this.bedListData[i].roomId) {
              item = layoutList[j];
            }
          }
          layoutData.push(item);
        }
        this.layout = layoutData;
      });
    },

    //传感器设置
    roomSetting(item) {
      console.log(item);
      bus.$emit("homePage", {
        type: "jump",
        path: "/roomDeviceSetting",
        title: "房间传感器设置",
        params: { roomId: item.roomId, isRoomSetting: true },
      });
      setTimeout(() => {
        bus.$emit("homePage", { type: "jump", path: "/roomDeviceSetting" });
      }, 1000);
    },

    //屏蔽报警
    closeWarning(item) {
      this.settingRoomId = item.roomId;
      this.warningDialogVisible = true;
      this.getWarning();
    },

    //查询屏蔽状态
    getWarning() {
      this.$get("dmc/roomAlertStatus/" + this.settingRoomId).then((res) => {
        this.warningForm.silentTime = res.defaultSilentTime;
        if (res.silentStatus == 0) {
          this.warningForm.onOff = false;
        } else if (res.silentStatus == 1) {
          this.warningForm.onOff = true;
        }
      });
    },

    //设置屏蔽时间
    settingTime() {
      let param = {
        roomId: this.settingRoomId,
        silentTime: this.warningForm.silentTime,
      };
      this.$postJson("dmc/roomSilentTime", param).then((res) => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
          this.getWarning();
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    //屏蔽开关
    changeStatus() {
      if (this.warningForm.onOff) {
        let param = {
          roomId: this.settingRoomId,
          silentTime: this.warningForm.silentTime,
        };
        this.$postJson("dmc/roomAlertStatus", param).then((res) => {
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getWarning();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$deleteList("dmc/roomAlertStatus/" + this.settingRoomId).then(
          (res) => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.getWarning();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          }
        );
      }
    },
  },
  mounted() {
    this.getBuildList();
    this.getSelfcareStatusList();
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.vue-grid-item.cssTransforms {
  background: #1d8ce0;
}

.centertext {
  position: absolute;
  left: 50%;
  top: 50%;
  color: white;
  font-size: 16px;
  transform: translate(-50%, -50%);
}

.box-card {
  font-size: 16px;
}
.el-card__body {
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
.buttontxt {
  width: 49%;
  text-align: center;
  display: inline-block;
  border: 0.5px solid #e4e4e4;
  font-size: 16px;
  padding-bottom: 8px;
  padding-top: 5px;
  cursor: pointer;
}
.big_col {
  width: 270px;
  margin-top: 10px;
}
.card {
  width: 250px;
  border: 1px solid #3a77e2;
  border-radius: 10px;
  padding-bottom: 12px;
}
.card_top {
  background: #3a77e2;
  width: 100%;
  height: 40px;
}
.card ::v-deep .el-card__body {
  padding: 0px;
}

.top_icon {
  float: right;
  color: white;
  font-size: 22px;
  text-align: center;
  margin-top: 9px;
  cursor: pointer;
  margin-right: 10px;
}
.card_text {
  padding-left: 10px;
  font-size: 15px;
  height: 20px;
  padding-top: 4px;
}

.el-tree-node {
  width: 100%;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(51, 122, 183);
  width: 120px;
  color: #fff;
  border-radius: 5px;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
